<div id="editDataMappingDtlDialog"
     class="modal modal-lg modal-dialog fade in"
     role="dialog"
     style="position:absolute !important"
     appDraggable
     dragTarget="#editDataMappingDtlDialog"
     dragHandle="#editDataMappingDtlDialogHeader">

  <div class="modal-content">

    <!-- ================= HEADER ================= -->
    <div class="modal-header" id="editDataMappingDtlDialogHeader">
      <button type="button" class="close" (click)="hideDialog()">
        <i class="fa fa-times"></i>
      </button>
      {{ isEditMode ? 'EDIT DATA MAPPING DETAIL' : 'ADD DATA MAPPING DETAIL' }}
    </div>

    <!-- ================= BODY ================= -->
    <div class="modal-body internal-well">

      <!-- Mapping Name -->
      <div class="form-group">
        <div class="row">
          <div class="col-sm-3">
            <label class="labelRequired">Mapping Name:</label>
          </div>
          <div class="col-sm-6">
            <input
              class="form-control"
              type="text"
              [(ngModel)]="name"
              [disabled]="isEditMode">
          </div>
        </div>
      </div>

      <br>

      <!-- CATEGORY -->
      <div class="form-group">
        <div class="row">
          <div class="col-sm-3">
            <label class="labelRequired">CATEGORY:</label>
          </div>
          <div class="col-sm-6">
            <select
              class="form-control"
              [(ngModel)]="selectedCategory"
              (change)="onCategoryChange(selectedCategory)"
              [disabled]="isUiDisabled ">

              <option [ngValue]="null">-- Select Category --</option>
              <option *ngFor="let cat of categories" [ngValue]="cat">
                {{ cat }}
              </option>

            </select>
          </div>
        </div>
      </div>

      <br>

      <!-- OBJECT -->
      <div class="form-group">
        <div class="row">
          <div class="col-sm-3">
            <label class="labelRequired">OBJECT:</label>
          </div>
          <div class="col-sm-6">
            <select
              class="form-control"
              [(ngModel)]="selectedObject"
              (ngModelChange)="onObjectChange($event)"
              [disabled]="isUiDisabled || !selectedCategory">

              <option [ngValue]="null">-- Select Object --</option>
              <option *ngFor="let obj of objects; trackBy: trackByObjectId"
                      [ngValue]="obj">
                {{ obj.name }}
              </option>

            </select>
          </div>
        </div>
      </div>

      <br>

      <!-- CSV -->
      <div class="form-group">
        <div class="row">
          <div class="col-sm-3">
            <label>CSV File:</label>
          </div>
          <div class="col-sm-6">
            <input
              type="file"
              accept=".csv"
              class="form-control"
              #csvFileInput
              (change)="onCsvFileSelected($event)" />
          </div>
        </div>
      </div>

      <br>

      <!-- PROPERTIES -->
      <div *ngIf="objectParams.length > 0">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Property</th>
              <th>Required</th>
              <th>Static?</th>
              <th>Value / Column</th>
              <th>LookUp</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of objectParams">
              <td>{{ p.name }}</td>

              <td class="text-center">
                <input type="checkbox" [checked]="p.opreq === '1'" disabled>
              </td>

              <td class="text-center">
                <input type="checkbox" [(ngModel)]="p.isStatic">
              </td>

              <td>
                <!-- STATIC -->
                <input
                  *ngIf="p.isStatic"
                  type="text"
                  class="form-control"
                  [(ngModel)]="p.valueOrColumn" />

                <!-- CSV COLUMN -->
                <input
                  *ngIf="!p.isStatic"
                  type="text"
                  class="form-control"
                  [ngModel]="p.valueOrColumn || ''"
                  (ngModelChange)="p.valueOrColumn = $event"
                  [typeahead]="csvHeaderResults$"
                  [typeaheadAsync]="true"
                  [typeaheadMinLength]="0"
                  placeholder="Search CSV column..." />
              </td>

              <td class="text-center">
                <input type="checkbox" [(ngModel)]="p.lookUp">
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <!-- ================= FOOTER ================= -->
    <div class="modal-footer">

      <button
        type="button"
        class="btn btn-default"
        (click)="onCancelClicked()"
        [disabled]="isUiDisabled">
        <i class="fa fa-ban"></i> CANCEL
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="onSaveClicked()"
        [disabled]="isUiDisabled">
        <i class="fa fa-save"></i> SAVE
      </button>

    </div>

  </div>
</div>

<ef-simple-success-error-dialog-box #successErrorDialog>
</ef-simple-success-error-dialog-box>